import {
  AddToMode,
  FormSubmission,
  SubmissionPaymentStatus
} from '@features/forms/types';
import { FormSubmissionApiItem } from '@features/forms/types/formSubmissionApi';

import { parseSubmissionPaymentAmount } from './parseSubmissionPaymentAmount';

export const mapSubmissionPaymentStatus = (
  settlementStatus?: string | null
): SubmissionPaymentStatus => {
  const normalized = settlementStatus?.toLowerCase().trim();
  if (normalized === 'processing') {
    return 'processing';
  }
  return 'paid';
};

export const mapAddToMode = (mode: string): AddToMode => {
  const normalized = mode.toLowerCase().replace(/-/g, '_');
  return normalized === 'member_list' ? 'member_list' : 'group';
};

export const mapFormSubmission = (
  item: FormSubmissionApiItem
): FormSubmission => {
  const addToMode = mapAddToMode(item.add_to_mode);

  return {
    id: item.id,
    name: item.name,
    phone: item.mobile,
    memberId: item.member_id,
    amountPaid: parseSubmissionPaymentAmount(item.paid_amount),
    totalAmount: parseSubmissionPaymentAmount(item.total_amount),
    addedTo: {
      mode: addToMode,
      groupId: item.group?.id,
      groupName: item.group?.name
    },
    source: item.source,
    paidAt: item.paid_at,
    formVersion: item.version,
    paymentId: item.payment_order_id,
    paymentStatus: mapSubmissionPaymentStatus(item.settlement_status),
    ...(item.admission_number ? { admissionNumber: item.admission_number } : {})
  };
};

export const mapFormSubmissions = (
  items: FormSubmissionApiItem[] | undefined
): FormSubmission[] => (items ?? []).map(mapFormSubmission);

export default mapFormSubmission;
